// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"30":"83fdf5c5","191":"7a7f687b","423":"ca5205fd","825":"08808948"}[chunkId] + ".css";
};